import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaHome, 
  FaBuilding, 
  FaCheckCircle, 
  FaMapMarkerAlt, 
  FaWifi, 
  FaUtensils,
  FaShower,
  FaParking,
  FaWhatsapp,
  FaStar,
  FaEuroSign,
  FaCalendarAlt,
  FaSearch,
  FaHeart,
  FaTrophy,
  FaClock,
  FaShieldAlt,
  FaQuoteLeft,
  FaRocket,
  FaPhoneAlt,
  FaChevronRight,
  FaBath,
  FaRegBuilding,
  FaCity,
  FaKey
} from 'react-icons/fa';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './HebergementEtudiant.css';

const HebergementEtudiant = () => {
  const [selectedCity, setSelectedCity] = useState('paris');
  const [activeFaq, setActiveFaq] = useState(null);

  const residences = [
    {
      id: 1,
      name: "Studéa Paris 13",
      city: "paris",
      location: "Paris 13ème",
      price: "550€/mois",
      rating: 4.5,
      reviews: 128,
      amenities: ["Wifi", "Cuisine équipée", "Salle de sport", "Laverie"],
      distance: "10 min métro",
      featured: true
    },
    {
      id: 2,
      name: "Les Estudines Lyon",
      city: "lyon",
      location: "Lyon 7ème",
      price: "480€/mois",
      rating: 4.3,
      reviews: 95,
      amenities: ["Wifi", "Cuisine", "Parking", "Local vélo"],
      distance: "15 min tram",
      featured: false
    },
    {
      id: 3,
      name: "Nexity Studéa Marseille",
      city: "marseille",
      location: "Marseille Centre",
      price: "520€/mois",
      rating: 4.4,
      reviews: 112,
      amenities: ["Wifi", "Piscine", "Salle de sport", "Terrasse"],
      distance: "5 min bus",
      featured: true
    },
    {
      id: 4,
      name: "Campus Vert Bordeaux",
      city: "bordeaux",
      location: "Bordeaux Talence",
      price: "450€/mois",
      rating: 4.6,
      reviews: 156,
      amenities: ["Wifi", "Jardin", "Salle d'étude", "Cafétéria"],
      distance: "8 min tram",
      featured: false
    },
    {
      id: 5,
      name: "Studéa Toulouse",
      city: "toulouse",
      location: "Toulouse Rangueil",
      price: "470€/mois",
      rating: 4.2,
      reviews: 87,
      amenities: ["Wifi", "Cuisine", "Parking", "Local vélos"],
      distance: "12 min métro",
      featured: false
    },
    {
      id: 6,
      name: "Les Estudines Lille",
      city: "lille",
      location: "Lille Centre",
      price: "490€/mois",
      rating: 4.4,
      reviews: 104,
      amenities: ["Wifi", "Salle de sport", "Laverie", "Cafétéria"],
      distance: "5 min métro",
      featured: true
    }
  ];

  const cities = [
    { id: "paris", name: "Paris", count: 45, region: "Île-de-France" },
    { id: "lyon", name: "Lyon", count: 28, region: "Auvergne-Rhône-Alpes" },
    { id: "marseille", name: "Marseille", count: 22, region: "Provence-Alpes-Côte d'Azur" },
    { id: "toulouse", name: "Toulouse", count: 18, region: "Occitanie" },
    { id: "bordeaux", name: "Bordeaux", count: 20, region: "Nouvelle-Aquitaine" },
    { id: "lille", name: "Lille", count: 15, region: "Hauts-de-France" },
    { id: "strasbourg", name: "Strasbourg", count: 12, region: "Grand Est" },
    { id: "nantes", name: "Nantes", count: 14, region: "Pays de la Loire" }
  ];

  const filteredResidences = residences.filter(r => r.city === selectedCity);
  const cityInfo = cities.find(c => c.id === selectedCity);

  const steps = [
    {
      id: 1,
      title: "Analyse des besoins",
      description: "Étude approfondie de votre budget, localisation souhaitée et critères spécifiques",
      icon: <FaSearch />,
      details: "Bilan personnalisé gratuit",
      color: "#dc143c"
    },
    {
      id: 2,
      title: "Sélection des résidences",
      description: "Présentation des meilleures options correspondant à votre profil",
      icon: <FaBuilding />,
      details: "Accès exclusif à 160+ résidences",
      color: "#2a5298"
    },
    {
      id: 3,
      title: "Visite virtuelle",
      description: "Découverte des résidences via vidéo ou visite guidée en direct",
      icon: <FaHome />,
      details: "Visites 360° disponibles",
      color: "#1e3c72"
    },
    {
      id: 4,
      title: "Réservation et dossier",
      description: "Assistance complète pour la constitution du dossier et la réservation",
      icon: <FaCalendarAlt />,
      details: "Garantie de logement en 48h",
      color: "#dc143c"
    }
  ];

  const benefits = [
    { icon: <FaTrophy />, title: "Accès exclusif à 160+ résidences étudiantes", desc: "Réseau privilégié de partenaires" },
    { icon: <FaEuroSign />, title: "Meilleurs prix garantis", desc: "Tarifs négociés pour nos étudiants" },
    { icon: <FaCheckCircle />, title: "Réservation sans frais de dossier", desc: "Économies sur les frais administratifs" },
    { icon: <FaClock />, title: "Garantie de logement en 48h", desc: "Solution rapide et efficace" },
    { icon: <FaShieldAlt />, title: "Accompagnement pour APL/CAF", desc: "Aide aux démarches administratives" },
    { icon: <FaSearch />, title: "État des lieux assisté", desc: "Accompagnement à l'arrivée" }
  ];

  const testimonials = [
    {
      name: "Sarah M.",
      country: "Maroc",
      residence: "Studéa Paris 13",
      quote: "Grâce à ETEF, j'ai trouvé un logement parfait en moins de 48h. L'équipe a été très réactive et professionnelle.",
      rating: 5
    },
    {
      name: "Lucas B.",
      country: "Cameroun",
      residence: "Les Estudines Lyon",
      quote: "Service exceptionnel ! Ils m'ont accompagné dans toutes les démarches et j'ai pu bénéficier des APL rapidement.",
      rating: 5
    },
    {
      name: "Amina T.",
      country: "Algérie",
      residence: "Campus Vert Bordeaux",
      quote: "La visite virtuelle m'a permis de choisir en toute confiance. Je recommande vivement ce service !",
      rating: 5
    }
  ];

  const faqs = [
    {
      q: "Quels sont les documents nécessaires pour réserver un logement ?",
      a: "Vous aurez besoin d'une pièce d'identité (passeport), de votre certificat de scolarité ou d'admission, d'un garant (ou d'une garantie VISALE), et de vos justificatifs de ressources. Nous vous aidons à constituer un dossier solide."
    },
    {
      q: "Puis-je bénéficier des APL (Aides au logement) ?",
      a: "Oui, la plupart de nos résidences sont conventionnées et éligibles aux APL. Nous vous accompagnons dans vos démarches auprès de la CAF et vous aidons à constituer votre dossier."
    },
    {
      q: "Quel est le délai pour trouver un logement ?",
      a: "Grâce à notre réseau de partenaires, nous pouvons trouver un logement adapté en 48h à 72h selon vos critères. Notre garantie 'logement en 48h' vous assure une solution rapide."
    },
    {
      q: "Proposez-vous des colocations ?",
      a: "Oui, nous proposons également des solutions de colocation dans certaines résidences, idéales pour partager les frais et créer du lien social. Nous vous aidons à trouver des colocataires si nécessaire."
    },
    {
      q: "Quels sont les frais supplémentaires ?",
      a: "En plus du loyer, il faut prévoir les charges (eau, électricité, chauffage) généralement incluses dans le loyer. Nous vous présentons toujours le coût total pour éviter les surprises."
    },
    {
      q: "Proposez-vous une garantie VISALE ?",
      a: "Oui, nous vous aidons à bénéficier de la garantie VISALE (gratuite pour les étudiants de moins de 30 ans) si vous n'avez pas de garant. Nous vous accompagnons dans toutes les démarches."
    }
  ];

  const stats = [
    { value: "160+", label: "Résidences partenaires" },
    { value: "48h", label: "Délai de réservation" },
    { value: "15+", label: "Villes couvertes" },
    { value: "98%", label: "Clients satisfaits" }
  ];

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="hebergement-service-page">
      <Header />
      
      {/* Hero Section with Animated Background */}
      <section className="hebergement-hero">
        <div className="hebergement-hero-bg">
          <div className="hebergement-hero-bg-gradient"></div>
          <div className="hebergement-hero-bg-particles"></div>
        </div>
        <div className="hebergement-hero-container">
          <div className="hebergement-hero-content">
            <div className="hebergement-badge">
              <FaHeart /> Logement garanti en 48h
            </div>
            <h1>Hébergement <span className="hebergement-gradient-text">Étudiant</span> en France</h1>
            <p>Trouvez votre logement idéal dans l'une de nos 160 résidences partenaires. Un accompagnement personnalisé pour une installation sereine.</p>
            <div className="hebergement-hero-actions">
              <Link to="/contact" className="hebergement-btn-primary">
                <FaRocket /> Trouver mon logement
              </Link>
              <Link to="/contact" className="hebergement-btn-outline">
                <FaPhoneAlt /> Conseil personnalisé
              </Link>
              <a href="https://wa.me/33695744027" className="hebergement-btn-whatsapp-hero">
                <FaWhatsapp /> Consultation gratuite
              </a>
            </div>
            <div className="hebergement-hero-stats">
              {stats.map((stat, index) => (
                <React.Fragment key={index}>
                  <div className="hebergement-stat-item">
                    <strong>{stat.value}</strong>
                    <span>{stat.label}</span>
                  </div>
                  {index < stats.length - 1 && <div className="hebergement-stat-divider"></div>}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
        <div className="hebergement-hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </section>

      {/* Process Section */}
      <section className="hebergement-process">
        <div className="hebergement-container">
          <div className="hebergement-section-header">
            <h2>Notre processus de recherche</h2>
            <p>Un accompagnement personnalisé en 4 étapes pour trouver votre chez-vous en France</p>
          </div>
          <div className="hebergement-steps-grid">
            {steps.map((step) => (
              <div key={step.id} className="hebergement-step-card">
                <div className="hebergement-step-number" style={{ background: step.color }}>{step.id}</div>
                <div className="hebergement-step-icon-wrapper" style={{ color: step.color }}>
                  {step.icon}
                </div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
                <span className="hebergement-step-detail">{step.details}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cities & Residences Section */}
      <section className="hebergement-residences">
        <div className="hebergement-container">
          <div className="hebergement-section-header">
            <h2>Nos résidences par ville</h2>
            <p>Sélectionnez votre ville d'études pour découvrir les logements disponibles</p>
          </div>
          
          <div className="hebergement-city-filters">
            {cities.map(city => (
              <button
                key={city.id}
                className={`hebergement-city-btn ${selectedCity === city.id ? 'active' : ''}`}
                onClick={() => setSelectedCity(city.id)}
              >
                <FaCity />
                {city.name}
                <span className="city-count">{city.count}</span>
              </button>
            ))}
          </div>

          <div className="hebergement-residences-grid">
            {filteredResidences.map(residence => (
              <div key={residence.id} className="hebergement-residence-card">
                {residence.featured && (
                  <div className="hebergement-featured-badge">
                    <FaStar /> Coup de cœur
                  </div>
                )}
                <div className="hebergement-residence-icon">
                  <FaRegBuilding />
                </div>
                <h3>{residence.name}</h3>
                <div className="hebergement-residence-location">
                  <FaMapMarkerAlt /> {residence.location}
                </div>
                <div className="hebergement-residence-distance">
                  <FaClock /> {residence.distance} de l'université
                </div>
                <div className="hebergement-residence-rating">
                  <div className="stars">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className={i < Math.floor(residence.rating) ? 'filled' : 'empty'} />
                    ))}
                  </div>
                  <span className="rating-value">{residence.rating}</span>
                  <span className="reviews-count">({residence.reviews} avis)</span>
                </div>
                <div className="hebergement-residence-price">
                  <FaEuroSign /> <strong>{residence.price}</strong>
                </div>
                <div className="hebergement-residence-amenities">
                  {residence.amenities.map((amenity, idx) => (
                    <span key={idx} className="hebergement-amenity-tag">
                      {amenity === "Wifi" && <FaWifi />}
                      {amenity === "Cuisine équipée" && <FaUtensils />}
                      {amenity === "Salle de sport" && <FaBuilding />}
                      {amenity === "Parking" && <FaParking />}
                      {amenity === "Laverie" && <FaShower />}
                      {amenity}
                    </span>
                  ))}
                </div>
                <Link to="/contact" className="hebergement-reserve-btn">
                  <FaKey /> Réserver maintenant
                </Link>
              </div>
            ))}
          </div>

          <div className="hebergement-more-info">
            <p>Plus de {cityInfo?.count} résidences disponibles à {cityInfo?.name} • {cityInfo?.region}</p>
            <Link to="/contact" className="hebergement-link-more">
              Voir toutes les résidences <FaChevronRight />
            </Link>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="hebergement-benefits">
        <div className="hebergement-container">
          <div className="hebergement-section-header">
            <h2>Pourquoi choisir notre service ?</h2>
            <p>Des avantages exclusifs pour votre installation en France</p>
          </div>
          <div className="hebergement-benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="hebergement-benefit-card">
                <div className="hebergement-benefit-icon-wrapper">
                  {benefit.icon}
                </div>
                <h4>{benefit.title}</h4>
                <p>{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="hebergement-testimonials">
        <div className="hebergement-container">
          <div className="hebergement-section-header">
            <h2>Ils ont trouvé leur <span className="hebergement-gradient-text">logement avec nous</span></h2>
            <p>Des étudiants satisfaits partagent leur expérience</p>
          </div>
          <div className="hebergement-testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="hebergement-testimonial-card">
                <div className="hebergement-testimonial-header">
                  <div className="hebergement-testimonial-avatar">
                    <FaHome />
                  </div>
                  <div className="hebergement-testimonial-rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                </div>
                <div className="hebergement-testimonial-quote-icon">
                  <FaQuoteLeft />
                </div>
                <p className="hebergement-testimonial-quote">"{testimonial.quote}"</p>
                <div className="hebergement-testimonial-author">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.country}</p>
                  <div className="hebergement-testimonial-residence">
                    <FaHome />
                    <span>{testimonial.residence}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section with Accordion */}
      <section className="hebergement-faq">
        <div className="hebergement-container">
          <div className="hebergement-section-header">
            <h2>Questions <span className="hebergement-gradient-text">fréquentes</span></h2>
            <p>Tout ce que vous devez savoir sur le logement étudiant en France</p>
          </div>
          <div className="hebergement-faq-grid">
            {faqs.map((faq, index) => (
              <div key={index} className="hebergement-faq-item">
                <button className="hebergement-faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.q}</span>
                  <FaChevronRight className={`hebergement-faq-icon ${activeFaq === index ? 'rotated' : ''}`} />
                </button>
                <div className={`hebergement-faq-answer ${activeFaq === index ? 'active' : ''}`}>
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="hebergement-cta">
        <div className="hebergement-container">
          <div className="hebergement-cta-wrapper">
            <div className="hebergement-cta-content">
              <h2>Prêt à trouver votre <br/>logement étudiant ?</h2>
              <p>Bénéficiez d'un conseil personnalisé gratuit pour trouver votre hébergement idéal en France</p>
              <div className="hebergement-cta-buttons">
                <Link to="/contact" className="hebergement-btn-cta-primary">
                  <FaSearch /> Je cherche un logement
                </Link>
                <a href="https://wa.me/33695744027" className="hebergement-btn-cta-whatsapp">
                  <FaWhatsapp /> Contactez-nous sur WhatsApp
                </a>
              </div>
              <div className="hebergement-cta-note">
                <FaShieldAlt /> Sans engagement, réponse garantie sous 24h
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HebergementEtudiant;